import React from "react";
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer-root">
      <div className="footer-content">
        <div className="footer-sections">
          <div className="footer-section">
            <h3 className="footer-title">FOR STUDENTS</h3>
            <ul className="footer-link-list">
              <li><a href="#" className="footer-link">STUDENT PORTAL</a></li>
              <li><Link to="/learning-resources" className="footer-link">LEARNING RESOURCES</Link></li>
            </ul>
          </div> 
          <div className="footer-section">
            <h3 className="footer-title">CAREERS AT BIYANI'S</h3>
            <ul className="footer-link-list">
              <li><Link to="/work-environment" className="footer-link">WORKING ENVIRONMENT</Link></li>
              <li><Link to="/apply-job" className="footer-link">APPLY FOR JOB</Link></li>
            </ul>
          </div>
        </div>
        <div className="footer-separator"></div>
        <div className="footer-social">
          <div className="footer-social-links">
            <a href="https://www.instagram.com/biyanis_super30?igsh=YTQ0M215cHYwZzR4" target="_blank" rel="noopener noreferrer" className="footer-social-link">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://youtube.com/@biyanissuper30eportal?si=Bd-6loXbwN8IVUwP" target="_blank" rel="noopener noreferrer" className="footer-social-link">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="https://www.facebook.com/biyanissuper30" target="_blank" rel="noopener noreferrer" className="footer-social-link">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="https://www.linkedin.com/company/biyani-s-education-group/" target="_blank" rel="noopener noreferrer" className="footer-social-link">
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a href="#" className="footer-social-link">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865l8.875 11.633Z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div className="footer-copyright">
        <div className="footer-copyright-separator"></div>
        <div className="footer-copyright-content">
          <p className="footer-copyright-text">© 2025 BIYANIS EDUCATION GROUP | ALL RIGHTS RESERVED</p>
          <Link to="/privacy-policy" className="footer-privacy-link">Privacy Policy</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
